import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './AboutUs.css';

// Slideshow Component
const Slideshow = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 9;
  
  // Auto-play slideshow
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % totalSlides);
    }, 4000); // Change slide every 4 seconds
    
    return () => clearInterval(timer);
  }, []);
  
  const goToSlide = (slideIndex) => {
    setCurrentSlide(slideIndex);
  };
  
  return (
    <div className="slideshow">
      <div className="slideshow-images">
        {[...Array(totalSlides)].map((_, index) => (
          <img
            key={index}
            src={`${process.env.PUBLIC_URL}/images/SlideShow/${index + 1}.png`}
            alt={`Slide ${index + 1}`}
            className={`slide-image ${currentSlide === index ? 'active' : ''}`}
          />
        ))}
      </div>
      <div className="slideshow-dots">
        {[...Array(totalSlides)].map((_, index) => (
          <span
            key={index}
            className={`dot ${currentSlide === index ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

// Diferenciais Slideshow Component
const DiferenciaisSlideshow = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const diferenciais = [
    {
      title: "Tecnologia Inteligente",
      description: "Automatizamos fluxos, centralizamos documentos e monitoramos prazos em tempo real, tornando processos corporativos mais rápidos, seguros e precisos."
    },
    {
      title: "Segurança Total",
      description: "Controle inteligente de rotinas e metodologias estruturadas garantem conformidade e redução de riscos, mesmo em operações complexas."
    },
    {
      title: "Alcance Global",
      description: "Atuação em órgãos públicos, entidades reguladoras e mercados corporativos, no Brasil e no exterior, com suporte completo em todas as regiões."
    },
    {
      title: "Soluções Personalizadas",
      description: "Backoffice jurídico, gestão documental e suporte operacional adaptados a cada empresa, otimizando recursos e liberando equipes para decisões estratégicas."
    },
    {
      title: "Experiência e Confiança",
      description: "Profissionais com expertise jurídica e operacional, combinados a inovação e relacionamento institucional, garantindo resultados confiáveis e consistentes."
    }
  ];
  
  const totalSlides = diferenciais.length;
  
  // Auto-play slideshow
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % totalSlides);
    }, 5000); // Change slide every 5 seconds
    
    return () => clearInterval(timer);
  }, [totalSlides]);
  
  const goToSlide = (slideIndex) => {
    setCurrentSlide(slideIndex);
  };
  
  return (
    <div className="diferenciais-slideshow">
      <div className="diferenciais-slides">
        {diferenciais.map((item, index) => (
          <div
            key={index}
            className={`diferencial-slide ${currentSlide === index ? 'active' : ''}`}
          >
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
      <div className="diferenciais-dots">
        {[...Array(totalSlides)].map((_, index) => (
          <span
            key={index}
            className={`diferencial-dot ${currentSlide === index ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

const SobreNosPage = () => {
  return (
    <>
      <Header />
      
      {/* Nossa História Section */}
      <section className="nossa-historia">
        <div className="nossa-historia-container">
          <div className="nossa-historia-left">
            <img 
              src={`${process.env.PUBLIC_URL}/images/NossaHistoria.jpg`} 
              alt="Nossa História" 
              className="nossa-historia-image"
            />
          </div>
          <div className="nossa-historia-right">
            <h1>NOSSA HISTÓRIA</h1>
            <p className="historia-intro">
              A Veridicus nasceu com a missão de transformar a gestão empresarial, integrando registros, 
              cadastros, licenças, compliance, processos e documentos em uma plataforma única e inteligente. 
              Fundada por profissionais com ampla experiência jurídica e operacional, a empresa combina 
              tecnologia de ponta, metodologia estruturada e conhecimento técnico, permitindo que operações 
              complexas sejam conduzidas com precisão, rapidez e total segurança.
            </p>
            <p>
              Nossa abordagem vai além da simples execução de tarefas: automatizamos fluxos, monitoramos 
              prazos em tempo real e centralizamos informações, garantindo que cada processo — seja a 
              gestão documental, o registro de marcas, a regularização societária, o acompanhamento em 
              órgãos públicos ou a terceirização de rotinas operacionais — seja realizado de forma eficiente e 
              confiável. Com isso, clientes de diversos setores podem focar no crescimento e nas decisões 
              estratégicas, enquanto nossa plataforma mantém toda a operação sob controle.
            </p>
            <p>
              Hoje, a Veridicus é referência em backoffice jurídico, gestão documental e suporte operacional, 
              atuando com alcance nacional e internacional. Com soluções sob medida para cada desafio, 
              oferecemos visibilidade completa, redução de riscos e otimização de recursos, tornando a 
              complexidade administrativa e regulatória mais simples, segura e ágil, e garantindo resultados 
              concretos para empresas de todos os portes.
            </p>
          </div>
        </div>
      </section>
      
      {/* Missão e Visão Section with Slideshow */}
      <section className="sobre-missao-visao">
        <div className="missao-visao-container">
          <div className="slideshow-wrapper">
            <Slideshow />
          </div>
          <div className="missao-visao-content">
            <div className="missao-card">
              <h3>Missão</h3>
              <p>
                Desburocratizar processos empresariais, simplificando registros, cadastros e licenças com eficiência,
                segurança e excelência, para que nossos clientes foquem no que realmente importa: o crescimento e
                o sucesso dos seus negócios — no Brasil e no exterior.
              </p>
            </div>
            
            <div className="visao-card">
              <h3>Visão</h3>
              <p>
                Ser referência em nível nacional e internacional em soluções de backoffice e gestão documental,
                reconhecida pela inovação, agilidade e confiança, impulsionando empresas a superarem barreiras burocráticas e
                alcançarem seus objetivos com tranquilidade, em qualquer parte do mundo.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Nossos Valores Section */}
      <section className="sobre-valores">
        <div className="valores-container">
          <h2>Nossos Valores</h2>
          <div className="valores-x-layout">
            <div className="valores-column left">
              <div className="valor-item">
                <h3>Foco no Cliente</h3>
                <p>Colocamos as necessidades de cada empresa no centro de tudo que fazemos, oferecendo soluções seguras, rápidas e confiáveis, tanto no Brasil quanto no exterior.</p>
              </div>
              
              <div className="valor-item">
                <h3>Clareza e Ética</h3>
                <p>Operamos com total transparência e integridade, garantindo visibilidade em cada etapa e fortalecendo a confiança entre clientes, parceiros e colaboradores.</p>
              </div>
            </div>
            
            <div className="valores-center">
              <div className="valor-item">
                <h3>Qualidade e Precisão</h3>
                <p>Buscamos excelência em cada serviço, utilizando tecnologia avançada e processos estruturados para entregar resultados consistentes, seguros e eficientes, independentemente da jurisdição.</p>
              </div>
            </div>
            
            <div className="valores-column right">
              <div className="valor-item">
                <h3>Inovação Contínua</h3>
                <p>Valorizamos a transformação digital e processos inteligentes, criando soluções que simplificam rotinas complexas e tornam a operação de nossos clientes mais ágil e estratégica.</p>
              </div>
              
              <div className="valor-item">
                <h3>Respeito e Colaboração</h3>
                <p>Atuamos com empatia, profissionalismo e responsabilidade, cultivando relacionamentos sólidos e duradouros em todos os mercados onde atuamos.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Our Team Section
      <section className="sobre-team">
        <div className="sobre-team-container">
          <div className="sobre-team-header">
            <h2>Nossa Equipe</h2>
            <p>
              A Veridicus conta com uma equipe multidisciplinar de profissionais experientes 
              e altamente qualificados, dedicados a oferecer o melhor atendimento e as 
              soluções mais eficientes para nossos clientes.
            </p>
          </div>
          
          <div className="sobre-team-grid">
            <div className="team-member">
              <div className="member-photo placeholder-photo">
                <span>JS</span>
              </div>
              <h3>João Silva</h3>
              <p className="member-role">Diretor Jurídico</p>
              <p className="member-desc">
                Advogado especialista em Direito Empresarial com mais de 15 anos de experiência 
                em registros comerciais e Juntas Comerciais em todo o Brasil.
              </p>
            </div>
            
            <div className="team-member">
              <div className="member-photo placeholder-photo">
                <span>MS</span>
              </div>
              <h3>Maria Santos</h3>
              <p className="member-role">Diretora de Operações</p>
              <p className="member-desc">
                Administradora com vasta experiência em processos de abertura e regularização 
                de empresas, especialista em otimização de procedimentos empresariais.
              </p>
            </div>
            
            <div className="team-member">
              <div className="member-photo placeholder-photo">
                <span>PR</span>
              </div>
              <h3>Pedro Rocha</h3>
              <p className="member-role">Coordenador de Atendimento</p>
              <p className="member-desc">
                Especialista em atendimento ao cliente, responsável por garantir a excelência 
                em todas as interações e a satisfação dos nossos clientes.
              </p>
            </div>
            
            <div className="team-member">
              <div className="member-photo placeholder-photo">
                <span>CA</span>
              </div>
              <h3>Carolina Almeida</h3>
              <p className="member-role">Consultora Empresarial</p>
              <p className="member-desc">
                Contadora com especialização em tributos empresariais, oferece consultoria 
                estratégica para abertura e alterações societárias.
              </p>
            </div>
          </div>
        </div>
      </section> */}
      
      {/* Our Differentials Section */}
      <section className="sobre-diferenciais">
        <div className="sobre-diferenciais-container">
          <div className="sobre-diferenciais-header">
            <h2>Nossos Diferenciais</h2>
            <p>
              Conheça o que torna a Veridicus uma empresa diferenciada no mercado 
              de registros comerciais.
            </p>
          </div>
          
          <DiferenciaisSlideshow />
        </div>
      </section>
      
      {/* Testimonials Section */}
      {/* <section className="sobre-testimonials">
        <div className="sobre-testimonials-container">
          <div className="sobre-testimonials-header">
            <h2>Depoimentos de Clientes</h2>
            <p>
              Veja o que nossos clientes dizem sobre a experiência 
              de trabalhar com a Veridicus.
            </p>
          </div>
          
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-quote">❝</div>
              <p className="testimonial-text">
                A Veridicus foi fundamental no processo de abertura da nossa empresa. 
                O atendimento personalizado e a rapidez no processo superaram todas as 
                nossas expectativas. Recomendo fortemente!
              </p>
              <div className="testimonial-author">
                <div className="author-photo placeholder-photo">
                  <span>RM</span>
                </div>
                <div className="author-info">
                  <h4>Roberto Mendes</h4>
                  <p>Diretor da Tech Solutions Ltda.</p>
                </div>
              </div>
            </div>
            
            <div className="testimonial-card">
              <div className="testimonial-quote">❝</div>
              <p className="testimonial-text">
                Precisávamos fazer uma alteração contratual urgente e a Veridicus 
                conduziu todo o processo com excelência e agilidade. A transparência 
                e o compromisso da equipe fizeram toda a diferença.
              </p>
              <div className="testimonial-author">
                <div className="author-photo placeholder-photo">
                  <span>AF</span>
                </div>
                <div className="author-info">
                  <h4>Ana Fernandes</h4>
                  <p>CEO da Bella Moda S.A.</p>
                </div>
              </div>
            </div>
            
            <div className="testimonial-card">
              <div className="testimonial-quote">❝</div>
              <p className="testimonial-text">
                Trabalhar com a Veridicus nos trouxe a segurança jurídica que 
                precisávamos para expandir nossos negócios. Equipe competente 
                e sempre disponível para esclarecer nossas dúvidas.
              </p>
              <div className="testimonial-author">
                <div className="author-photo placeholder-photo">
                  <span>CL</span>
                </div>
                <div className="author-info">
                  <h4>Carlos Lima</h4>
                  <p>Fundador da Construtora Horizonte</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      
      {/* CTA Section */}
      <section className="sobre-cta">
        <div className="sobre-cta-content">
          <h2>Pronto para simplificar seus registros comerciais?</h2>
          <p>
            Tecnologia e expertise para simplificar registros,
            compliance e gestão documental, no Brasil e no mundo.
          </p>
          <div className="sobre-cta-buttons">
            <Link to="/contato" className="cta-button primary">Fale Conosco</Link>
            <Link to="/nossos-servicos" className="cta-button secondary">Conheça Nossos Serviços</Link>
          </div>
        </div>
      </section>
      
      <Footer />
    </>
  );
};

export default SobreNosPage;